import UFOSegment from "@atlaskit/react-ufo/segment";

import { SocialEndorsement } from "@/components/confluence/product-tour/src/social-endorsement";

const SocialEndorsementSection = () => (
    <UFOSegment name="confluence-pt-cfind-1234-socialEndorsementSection">
        <SocialEndorsement />
    </UFOSegment>
);

SocialEndorsementSection.displayName = "SocialEndorsementSection";

export default SocialEndorsementSection;
